import React, { useContext, useState } from "react";
import {
  faCancel,
  faCheckCircle,
  faClose,
  // eslint-disable-next-line no-unused-vars
  faSpinner,
  // faUserPlus,
  faWifi,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MessageModal from "./MessageModal";
// eslint-disable-next-line no-unused-vars
import useSWR, { mutate } from "swr";
import TableTotalNCost from "./TableTotalNCost";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import TopActionMenus from "./TopActionMenus";
import SearchFilter from "./SearchFilter";
import { useNavigationEvent } from "navigation-react";
import LoaderAnimation from "./LoaderAnimationLarge";
import { AppContext } from "./AppContext";
import SecureLS from "secure-ls";
import EditCTScanAssignRegister from "./EditCTScanAssignRegister";
const ls = new SecureLS({ encodingType: "aes" });

function parseDate(dateStr) {
  if (!dateStr) return null;

  // Try parsing as ISO format first (from date inputs)
  const isoDate = new Date(dateStr);
  if (!isNaN(isoDate.getTime())) return isoDate;

  // Try parsing as DD/MM/YYYY format
  const parts = dateStr.split("/");
  if (parts.length === 3) {
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // months are 0-based
    const year = parseInt(parts[2], 10);
    const parsedDate = new Date(year, month, day);
    if (!isNaN(parsedDate.getTime())) return parsedDate;
  }

  return null;
}

const CtScanAssignRegister = () => {
  const { data, stateNavigator } = useNavigationEvent();
  // const [loading, setLoading] = useState(false);
  const [editAssignData, setEditAssignData] = useState("");
  const [modalEditRequest, setModalEditRequest] = useState(false);
  const [modalAssignRequest, setModalAssignRequest] = useState(false);
  const [isMessageModalIsNotOk, setIsMessageModalIsNotOk] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [modalMessages, setModalMessages] = useState("");
  const { setSelectedData } = useContext(AppContext);

  const perm = ls.get("currentuserrole") || [];
  console.log("permissions::", perm);

  const usercsrf_token = ls.get("usercsrf_token");

  const fetcher = (url) =>
    fetch(url, {
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": usercsrf_token,
      },
    })
      .then((res) => res.json())
      .then((data) => (Array.isArray(data) ? data : [data]));

  const [searchTerm, setSearchTerm] = useState("");
  // Request Date filters
  const [requestStartDate, setRequestStartDate] = useState("");
  const [requestEndDate, setRequestEndDate] = useState("");

  // Reported Date filters
  const [reportedStartDate, setReportedStartDate] = useState("");
  const [reportedEndDate, setReportedEndDate] = useState("");

  // Status filter
  const [statusFilter, setStatusFilter] = useState("");

  const [isMessageModalVisibleEdit, setIsMessageModalVisibleEdit] =
    useState(false);

  const [isMessageModalError, setIsMessageModalError] = useState(false);

  const [isMessageModalVisibleAssigned, setIsMessageModalVisibleAssigned] =
    useState(false);

  const {
    data: ctrequestsData,
    error: ctrequestsDataError,
    isLoading: ctrequestsDataLoading,
  } = useSWR(`${process.env.REACT_APP_CT_SCAN_ASSIGNED_REQUEST_URL}`, fetcher);
  console.log("CT SCAN REQUEST DATA", ctrequestsData);

  const filteredData = Array.isArray(ctrequestsData)
    ? ctrequestsData.filter((request) => {
        const matchesSearchTerm =
          request.field_patient_id
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          request.title_1?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          request.field_investigation_price
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_payment_amount
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_payment_amount_1
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_assigned_radiologist
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase());

        // Status filtering
        const matchesStatus =
          !statusFilter ||
          request.field_ct_scan_request_status?.toLowerCase() ===
            statusFilter.toLowerCase();

        // Request Date filtering
        const requestDate = parseDate(request.created);
        const reqStart = requestStartDate ? new Date(requestStartDate) : null;
        const reqEnd = requestEndDate ? new Date(requestEndDate) : null;

        // Reported Date filtering
        const reportedDate = parseDate(request.created_2);
        const repStart = reportedStartDate ? new Date(reportedStartDate) : null;
        const repEnd = reportedEndDate ? new Date(reportedEndDate) : null;

        // Normalize dates by setting time components
        if (reqStart) reqStart.setHours(0, 0, 0, 0);
        if (reqEnd) reqEnd.setHours(23, 59, 59, 999);
        if (requestDate) requestDate.setHours(12, 0, 0, 0);

        if (repStart) repStart.setHours(0, 0, 0, 0);
        if (repEnd) repEnd.setHours(23, 59, 59, 999);
        if (reportedDate) reportedDate.setHours(12, 0, 0, 0);

        const isInRequestDateRange =
          (!reqStart || (requestDate && requestDate >= reqStart)) &&
          (!reqEnd || (requestDate && requestDate <= reqEnd));

        const isInReportedDateRange =
          (!repStart || (reportedDate && reportedDate >= repStart)) &&
          (!repEnd || (reportedDate && reportedDate <= repEnd));

        return (
          matchesSearchTerm &&
          matchesStatus &&
          isInRequestDateRange &&
          isInReportedDateRange
        );
      })
    : [];

  const {
    data: ctscanAssignedRadioData,
    error: ctscanAssignedRadioError,
    isLoading: ctscanAssignedRadioLoading,
  } = useSWR(
    `${process.env.REACT_APP_ASSIGNED_RADIOLOGIST_API}?_format=json`,
    fetcher
  );
  console.log("CT SCAN ASSIGNED RADIOLOGIST DATA", ctscanAssignedRadioData);

  const {
    data: investigationsData,
    error: investigationsError,
    isLoading: investigationsLoading,
  } = useSWR(
    `${process.env.REACT_APP_INVESTIGATIONS_API}?_format=json`,
    fetcher
  );
  console.log("INVESTIGATIONS DATA", investigationsData);

  const toggleModalEditRequest = () => {
    setModalEditRequest(!modalEditRequest);
  };

  const toggleModalAssignRequest = () => {
    setModalAssignRequest(!modalAssignRequest);
  };

  const toggleModalError = () => {
    setIsMessageModalError(!isMessageModalError);
  };

  const toggleModalIsNotOk = () => {
    setIsMessageModalIsNotOk(!isMessageModalIsNotOk);
  };

  if (ctrequestsDataError || ctscanAssignedRadioError || investigationsError) {
    return (
      <LoaderAnimation
        loadingTxt={`Check your network / internet connection and try again!, ${ctrequestsDataError}`}
      />
    );
  }

  const getStatusStyle = (status) => {
    switch (status) {
      case "Pending":
        return { color: "red" };
      case "Assigned":
        return { color: "yellow" };
      case "Completed":
        return { color: "green" };
      default:
        return { color: "gray" };
    }
  };

  if (
    ctrequestsDataLoading ||
    ctscanAssignedRadioLoading ||
    investigationsLoading
  ) {
    return <LoaderAnimation loadingTxt="Loading..." />;
  }

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />

      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="patient-register">
          <TopActionMenus AddTitle="CT Scan Assign register" />
          <SearchFilter
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            requestStartDate={requestStartDate}
            setRequestStartDate={setRequestStartDate}
            requestEndDate={requestEndDate}
            setRequestEndDate={setRequestEndDate}
            reportedStartDate={reportedStartDate}
            setReportedStartDate={setReportedStartDate}
            reportedEndDate={reportedEndDate}
            setReportedEndDate={setReportedEndDate}
          />
          {filteredData?.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <td>Patient ID</td>
                  <td>Patient Full Name</td>
                  <td>Investigation</td>
                  <td>Investigation Cost (GHC)</td>
                  <td>Radiologist</td>
                  <td>Request Date</td>
                  <td>Report Date</td>
                  <td>Report Status</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((ctrequests) => (
                  <tr key={ctrequests.nid}>
                    <td>{ctrequests.field_patient_id}</td>
                    <td>
                      {ctrequests.title === "Patient yet to be attached" ? (
                        <span className="tableyettobeadded">
                          Patient yet to be attached
                        </span>
                      ) : (
                        ctrequests.title
                      )}
                    </td>
                    <td>{ctrequests.investigation}</td>
                    <td>{ctrequests.field_investigation_price}</td>
                    <td> {ctrequests.field_assigned_radiologist}</td>
                    <td>{ctrequests.request_date}</td>
                    <td>{ctrequests.report_date}</td>
                    <td
                      style={getStatusStyle(
                        ctrequests.field_ct_scan_report_status
                      )}
                    >
                      {ctrequests.field_ct_scan_report_status}
                    </td>
                    <td className="formActionBtn">
                      <button
                        className="btn-modal"
                        onClick={() => {
                          setEditAssignData(ctrequests);
                          console.log("Edit Data:", ctrequests);
                          toggleModalAssignRequest();
                        }}
                      >
                        Assign
                      </button>
                      <button
                        onClick={() => {
                          const reportData = {
                            request_nid: ctrequests.request_nid,
                            request_uuid: ctrequests.request_uuid,
                            patient_fullname: ctrequests.patient_fullname,
                            patient_field_patient_id:
                              ctrequests.field_patient_id,
                            patient_nid: ctrequests.patient_nid,
                            patient_gender: ctrequests.field_gender,
                            patient_date_of_birth:
                              ctrequests.field_date_of_birth,
                            requester_first_name:
                              ctrequests.requester_first_name,
                            requester_last_name: ctrequests.requester_last_name,
                            request_date_created: ctrequests.request_date,
                            report_date_created: ctrequests.report_date,
                            report_nid: ctrequests.report_nid,
                            report_field_ct_scan_report_status:
                              ctrequests.field_ct_scan_report_status,
                            report_report_main_title:
                              ctrequests.report_main_title,
                            report_field_specialty: ctrequests.field_specialty,
                            report_field_ct_scan_report_technique:
                              ctrequests.field_ct_scan_report_technique,
                            report_field_ct_scan_report_findings:
                              ctrequests.field_ct_scan_report_findings,
                            report_field_ct_scan_report_impression:
                              ctrequests.field_ct_scan_report_impression,
                            request_investigation: ctrequests.investigation,
                            request_clinical_diag:
                              ctrequests.field_ct_scan_clinical_diagnosis,
                            request_comments: ctrequests.field_ct_scan_comments,
                            report_uuid: ctrequests.report_uuid,
                          };
                          setSelectedData(reportData);
                          stateNavigator.navigate("viewctscanreportregister");
                        }}
                      >
                        View report
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <LoaderAnimation loadingTxt="Loading report register" />
          )}

          {filteredData?.length > 0 && (
            <TableTotalNCost
              noOfReportLable="Number of request :"
              noOfReportLength={filteredData?.length}
              totalFeeCostLable="Total Fee Cost :"
              totalFeeCostValue={filteredData.reduce((total, report) => {
                const amount = Number(report?.field_payment_amount) || 0;
                return total + amount;
              }, 0)}
            />
          )}

          {modalAssignRequest && (
            <div className="modal">
              <div className="overlay"></div>
              <div className="modal-content">
                <div className="modal-body">
                  <div className="modal-header">
                    <p>{`Updating ${data?.ct_scan_patient_reference} request`}</p>
                    <button
                      className="close-modal"
                      onClick={toggleModalAssignRequest}
                    >
                      <FontAwesomeIcon icon={faClose} />
                    </button>
                  </div>
                  <EditCTScanAssignRegister
                    assignData={editAssignData}
                    ctscanAssignedRadioData={ctscanAssignedRadioData}
                    toggleModalAssignRequest={toggleModalAssignRequest}
                    setIsMessageModalVisibleAssigned={
                      setIsMessageModalVisibleAssigned
                    }
                  />
                </div>
              </div>
            </div>
          )}

          {isMessageModalVisibleEdit && (
            <MessageModal
              leftIcon={faCheckCircle}
              color="green"
              fontSize={20}
              message="Request updated successfully!"
              onClose={() =>
                setIsMessageModalVisibleEdit(false, toggleModalEditRequest())
              }
              rightIcon={faClose}
            />
          )}

          {isMessageModalVisibleAssigned && (
            <MessageModal
              leftIcon={faCheckCircle}
              color="green"
              fontSize={20}
              message="Request Assigned successfully!"
              onClose={() =>
                setIsMessageModalVisibleAssigned(
                  false,
                  toggleModalAssignRequest()
                )
              }
              rightIcon={faClose}
            />
          )}
          {isMessageModalError && (
            <MessageModal
              leftIcon={faWifi}
              color="red"
              fontSize={20}
              message="Error, check your internet connection and try again!"
              onClose={() => {
                toggleModalError();
              }}
              rightIcon={faClose}
            />
          )}
          {isMessageModalIsNotOk && (
            <MessageModal
              leftIcon={faCancel}
              color="red"
              fontSize={20}
              message={modalMessages}
              onClose={() => {
                toggleModalIsNotOk();
              }}
              rightIcon={faClose}
            />
          )}
        </div>
      </div>

      <DashboardContentFooter />
    </div>
  );
};

export default CtScanAssignRegister;
